module.exports = __webpack_public_path__ + "assets/img/TON.d80a2ae0.png";